import { render } from "./rte-content.vue?vue&type=template&id=11020bc0"
import script from "./rte-content.vue?vue&type=script&lang=js"
export * from "./rte-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__